import type { HomepageUpdate as Update } from "../../shared/homepage-update";
import "./homepage-update.css";

function linkTarget(url: string) {
  return url.startsWith("https://") ? { target: "_blank", rel: "noopener noreferrer" } : {};
}

export function HomepageUpdate({ update }: { update: Update }) {
  return (
    <aside className={`homepage-update${update.logo ? "" : " homepage-update--no-logo"}`} aria-label={update.label}>
      {update.logo && <img className="homepage-update-logo" src={update.logo.src} alt={update.logo.alt} width={80} height={23} />}
      <div className="homepage-update-copy">
        <div className="homepage-update-heading">
          <span className="homepage-update-label">{update.label}</span>
          <h2>
            {update.headline.lead && <>{update.headline.lead} </>}
            <strong>{update.headline.emphasis}</strong>
            {update.headline.context && <> <span>{update.headline.context}</span></>}
          </h2>
        </div>
        <p className="homepage-update-description">{update.description}</p>
        {(update.schedule || update.location) && <div className="homepage-update-meta">
          {update.schedule && <time dateTime={update.schedule.dateTime}>{update.schedule.label}</time>}
          {update.schedule && update.location && <span className="homepage-update-separator" aria-hidden="true">·</span>}
          {update.location && <a href={update.location.url} aria-label={update.location.accessibleLabel} {...linkTarget(update.location.url)}>{update.location.label}</a>}
        </div>}
      </div>
      <a className="profile-link homepage-update-cta" href={update.cta.url} aria-label={update.cta.accessibleLabel} {...linkTarget(update.cta.url)}>{update.cta.label}</a>
    </aside>
  );
}
